/*******************************************************************************************
   _____            __              ____   ____                         .__               
  /  _  \   _______/  |________  ___\   \ /   /____   ____  __ __  _____|__|____    ____  
 /  /_\  \ /  ___/\   __\_  __ \/  _ \   Y   // __ \ /    \|  |  \/  ___/  \__  \  /    \ 
/    |    \\___ \  |  |  |  | \(  <_> )     /\  ___/|   |  \  |  /\___ \|  |/ __ \|   |  \
\____|__  /____  > |__|  |__|   \____/ \___/  \___  >___|  /____//____  >__(____  /___|  /
        \/     \/                                 \/     \/           \/        \/     \/ 
********************************************************************************************
QueryParamProvider
********************************************************************************************

Author:     Nicholas Hamilton, PhD
Email:      nicholasehamilton@gmail.com
Date:       4th April 2025

*******************************************************************************************/
import React                                from 'react';
import { parse, stringify }                 from 'query-string';
import { 
  QueryParamProvider as BaseQueryParamProvider, 
  Adapter
}                                           from 'hooks/useQueryParams';

const OPTIONS = {
    // updateType              : 'pushIn',
    updateType              : 'replaceIn',
    // includeAllParams        : false,
    // removeDefaultsFromUrl   : true,
    // enableBatching          : true,
    skipUpdateWhenNoChange  : true,
    // includeAllParams        : false,
    searchStringToObject    : parse,
    objectToSearchString    : stringify
}

export const QueryParamProvider = (props) => <BaseQueryParamProvider {...props} adapter = {Adapter} options = {OPTIONS} />

export default QueryParamProvider;